import type { Tab } from "types/tabs.types"

export const getAPITabsConfig = (): Tab[] => [
  {
    labelKey: "tabs.DOCUMENTATION",
    value: 0,
    to: { pathname: "" },
  },
  {
    labelKey: "tabs.TOKEN",
    value: 1,
    to: { pathname: "create-token" },
  },
]
